// Schéma de couleurs de la marque (fond crème, bouton rose) appliqué à la barre collante.
const STICKY_COLOR_SCHEME = 'color-scheme-b53d625e-70a2-4e6d-b620-ef0ec92b40d6';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.content = null;
    this.formInView = true;
    this.footerInView = false;
    this.formObserver = null;
    this.footerObserver = null;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.content = this.querySelector('.sticky-add-to-cart__content');

    if (!this.form || !this.content) return;

    // Réserve l'espace du sticky dans le flux pour éviter le changement de
    // hauteur du document quand le contenu passe en position: fixed. Sans cela,
    // le contenu sort du flux → la page raccourcit → le footer remonte dans le
    // viewport → le sticky se désactive → boucle infinie de clignotement.
    requestAnimationFrame(() => {
      this.style.minHeight = `${this.offsetHeight}px`;
      this.#initObservers();
    });
  }

  disconnectedCallback() {
    this.formObserver?.disconnect();
    this.footerObserver?.disconnect();
  }

  #initObservers() {
    this.formObserver = new IntersectionObserver(([entry]) => {
      this.formInView = entry.isIntersecting;
      this.#updateDisplay();
    });

    this.formObserver.observe(this.form);

    if (!this.footer) return;

    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.footerInView = entry.isIntersecting;
      this.#updateDisplay();
    });

    this.footerObserver.observe(this.footer);
  }

  #updateDisplay() {
    const shouldBeActive = !this.formInView && !this.footerInView;
    const isActive = this.dataset.active === 'true';

    if (shouldBeActive === isActive) return;

    clearTimeout(this.closingTimeout);

    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add(STICKY_COLOR_SCHEME);
      return;
    }

    this.dataset.active = 'false';
    this.dataset.closing = 'true';

    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove(STICKY_COLOR_SCHEME);
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
